import request from '@/utils/request'
export function getPage(condition, pagination) {
    return request({
      url: "/base/tax/page",
      method: "post",
      data: { condition: condition, pagination: pagination },
    });
  }
  
  export function saveOrUpdate(data) {
    return request({
      url: "/base/tax/saveOrUpdate",
      method: "post",
      data,
    });
  }
  
  export function get(id) {
    return request({
      url: "/base/tax/get",
      method: "get",
      params: { id },
    });
  }
  
  export function deleteById(id) {
    return request({
      url: "/base/tax/deleteById",
      method: "post",
      data: { id: id },
    });
  }